import {configureStore} from '@reduxjs/toolkit';
import alertsSlice from './slices/alertsSlice';
import catalogSlice from './slices/catalogSlice';
import authSlice from './slices/authSlice';
import notificationSlice from './slices/notificationSlice';
import chatSlice from "./slices/chatSlice.ts";
import userSlice from './slices/userSlice.ts';
import noteSlice from './slices/noteSlice.ts';

const store = configureStore({
  reducer: {
    alerts: alertsSlice,
    catalog: catalogSlice,
    auth: authSlice,
    notification: notificationSlice,
    chat: chatSlice,
    user: userSlice,
    note: noteSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
